export const NOTICES_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    POPUP_LOADING: "POPUP_LOADING",
    POPUP_READY: "POPUP_READY",
}

export const NOTICES_STATES_MESSAGE_MAP = {
    [NOTICES_STATES.GRID_LOADING]: "",
    [NOTICES_STATES.POPUP_LOADING]: "",
}
